import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { IDesignMethodRestService } from "./design-method-rest";
import { ISkuAttributeValue } from "./model/dto/skuAttributeValue";
import { IProductDesignMethod } from "./model/domain/productDesignMethod";

export class DesignMethodRestService extends AbstractAccessorService<IProductDesignMethod> implements IDesignMethodRestService {

    public readonly $name: string = "designMethodRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<any>) {
        super();
    }
    /**
     * @description 获取产品属性表单（V1属性表单）对应可选的产品设计模式
     * @param productId
     * @param skuAttributeValues
     * @param profileId
     * @param versionedAttributeId
     * */
    calculateDesignMethod(productId: string, skuAttributeValues: Array<ISkuAttributeValue>,profileId:string|undefined, versionedAttributeId?: number): angular.IPromise<IResponse<IProductDesignMethod>> {
    
        return this.$accessor<IProductDesignMethod, Array<ISkuAttributeValue>, { productId: string ,profileId:string|undefined,versionedAttributeId?:number},'calculateDesignMethod'>(this.$name, "calculateDesignMethod", {
            parameter: {
                productId: productId,
                profileId:profileId,
                versionedAttributeId:versionedAttributeId
            },
            data: skuAttributeValues
        })
    }

    /**
     * @description 获取产品属性表单（V2属性表单）对应可选的产品设计模式
     * @param productId
     * @param formId
     * */
    getByFormId(productId:string,formId:number): angular.IPromise<IResponse<IProductDesignMethod>> {
        return this.$accessor<IProductDesignMethod,{ productId: string ,formId:number}, 'getByFormId'>(this.$name, "getByFormId", {
            parameter: {
                productId: productId,
                formId:formId
            }
        })
    }
}

